import { Model } from '@vuex-orm/core'
import {
  BooleanField,
  NumberField,
  OrmModel,
  StringField
} from 'vuex-orm-decorators'
import stringToColor from 'string-to-color'
import { SERVICE_COLOR_MAPPER } from '@/constants'

@OrmModel('services')
export default class Service extends Model {
  @NumberField()
  public id: number
  @StringField()
  public name: string
  @StringField()
  public abbreviation: string
  @BooleanField()
  public is_archived: boolean

  /**
   * Get color code for Service.
   */
  get color(): string {
    return (
      SERVICE_COLOR_MAPPER[this.abbreviation] ||
      stringToColor(this.abbreviation + 'yellow light')
    )
  }

  /**
   * Designed to use for sorting as parameter for
   * Array.prototype.sort()
   */
  static compare(item1: Service, item2: Service): number {
    // ignore upper and lowercase
    const name1 = item1.name.toLowerCase()
    const name2 = item2.name.toLowerCase()
    return name1.localeCompare(name2)
  }
}
